/*
  Mobile dock — version adaptée au moteur Be Yours 5.4.0.
  Différences avec la 9.3.0 : pas de <sticky-header>, ouverture des overlays
  en déclenchant les contrôles existants du header (details/summary).
*/
class MobileDock extends HTMLElement {
  connectedCallback() {
    const header = document.querySelector('.shopify-section-header');
    this.revealY = header ? Math.max(0, parseInt(header.getBoundingClientRect().bottom, 10)) : 0;

    if (window.Shopify && window.Shopify.designMode) {
      this.revealY = 0;
    }

    this.querySelectorAll('.dock__item[data-action]').forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });

    this.scrollTicking = false;
    this.onScrollHandler = () => {
      if (this.scrollTicking) return;
      this.scrollTicking = true;
      requestAnimationFrame(() => {
        this.onScroll();
        this.scrollTicking = false;
      });
    };
    window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    this.onScroll();

    this.setHeight = () => {
      document.documentElement.style.setProperty('--mobile-dock-height', `${this.offsetHeight}px`);
    };
    this.setHeight();
    window.addEventListener('resize', this.setHeight);
    window.addEventListener('load', this.setHeight, { once: true });

    this.syncCartBubble();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
    window.removeEventListener('resize', this.setHeight);
    if (this.bubbleObserver) this.bubbleObserver.disconnect();
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.classList.toggle('is-active', scrollTop >= this.revealY);
  }

  /* Le header 5.4 re-rend #cart-icon-bubble après un ajout au panier :
     on recopie sa pastille dans la barre mobile. */
  syncCartBubble() {
    const source = document.getElementById('cart-icon-bubble');
    const target = document.getElementById('mobile-cart-icon-bubble');
    if (!source || !target) return;

    const copy = () => {
      const bubble = source.querySelector('.cart-count-bubble');
      target.innerHTML = bubble ? bubble.outerHTML : '';
    };

    copy();
    this.bubbleObserver = new MutationObserver(copy);
    this.bubbleObserver.observe(source, { childList: true, subtree: true, characterData: true });
  }

  onButtonClick(event) {
    event.preventDefault();
    const action = event.currentTarget.dataset.action;

    switch (action) {
      case 'cart': {
        const miniCart = document.querySelector('mini-cart');
        if (miniCart && typeof miniCart.open === 'function' && this.isUsable(miniCart)) {
          this.scrollToTop(() => miniCart.open());
        } else {
          window.location.href = window.routes ? window.routes.cart_url : '/cart';
        }
        break;
      }

      case 'menu': {
        const summary = this.visibleSummary('header-drawer details > summary');
        if (!summary) break;
        /* Le menu 5.4 est en position:absolute sous le header : si la page est
           défilée, il s'ouvrirait hors écran. On remonte d'abord en haut. */
        this.scrollToTop(() => this.openDetails(summary));
        break;
      }

      case 'search': {
        const summary = this.visibleSummary('search-modal summary');
        if (!summary) {
          window.location.href = '/search';
          break;
        }
        this.scrollToTop(() => {
          const opened = this.openDetails(summary);
          if (!opened) {
            window.location.href = '/search';
            return;
          }
          const modal = summary.closest('search-modal');
          const input = modal && modal.querySelector('input[type="search"], input:not([type="hidden"])');
          if (input) setTimeout(() => input.focus(), 200);
        });
        break;
      }
    }
  }

  /* Remonte en haut de page puis exécute l'action (les overlays du thème 5.4
     sont ancrés au header). */
  scrollToTop(callback) {
    if (window.pageYOffset < 5) {
      callback();
      return;
    }
    window.scrollTo({ top: 0, behavior: 'auto' });
    requestAnimationFrame(() => setTimeout(callback, 80));
  }

  /* Ouvre le <details> via un vrai clic sur le <summary> (pour déclencher la
     logique du thème), avec repli sur l'attribut open. */
  openDetails(summary) {
    const details = summary.parentElement;
    if (details && details.open) return true;
    summary.click();
    if (details && !details.open) {
      details.open = true;
      details.dispatchEvent(new Event('toggle'));
    }
    return !details || details.open;
  }

  isUsable(element) {
    return element.offsetParent !== null || window.getComputedStyle(element).display !== 'none';
  }

  /* Le thème duplique header-drawer / search-modal (versions mobile et desktop) :
     on ne cible que celle réellement affichée. */
  visibleSummary(selector) {
    return Array.from(document.querySelectorAll(selector)).find((el) => {
      const host = el.closest('search-modal, header-drawer') || el;
      return host.getClientRects().length > 0;
    });
  }
}

if (!customElements.get('mobile-dock')) {
  customElements.define('mobile-dock', MobileDock);
}
